/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tag Category update input
 * @export
 * @interface TagCategoryUpdateModel
 */
export interface TagCategoryUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof TagCategoryUpdateModel
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TagCategoryUpdateModel
     */
    settings: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof TagCategoryUpdateModel
     */
    id: number;
}

export function TagCategoryUpdateModelFromJSON(json: any): TagCategoryUpdateModel {
    return TagCategoryUpdateModelFromJSONTyped(json, false);
}

export function TagCategoryUpdateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagCategoryUpdateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'settings': json['settings'],
        'id': json['id'],
    };
}

export function TagCategoryUpdateModelToJSON(value?: TagCategoryUpdateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'settings': value.settings,
        'id': value.id,
    };
}


